import React from 'react';
import { Placeholder } from './Placeholder';
interface RichTextProps {
  text: string;
}

// Renders text, highlighting any {{placeholder}} segments.
export function RichText({
  text
}: RichTextProps) {
  const parts = text.split(/(\{\{[^}]+\}\})/g).filter(Boolean);
  return <>
      {parts.map((part, i) => part.startsWith('{{') ? <Placeholder key={i} data-id="element-190" data-mp="fvaeyd7b1car">{part.slice(2, -2)}</Placeholder> : <React.Fragment key={i} data-id="element-191" data-mp="3f9w28odz8d4l">{part}</React.Fragment>)}
    </>;
}